const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();
const UserServices = require("Sources/services/user-services");
const StorageController = require("Sources/controllers/storage-controller");
const AppError = require("Sources/models/app-error");

let LoginManager = {};

((LoginManager) =>
{
  LoginManager.ERRORS = {
    USERNAME_PASSWORD_INCORRECT: "username_password_incorrect",
    INCOMPLETE_PROFILE: "incomplete_profile",
    USER_NOT_VERIFIED: "user_not_verified",
    NO_USER_DATA: "no_user_data",
    UNEXPECTED: "unexpected"
  };

  LoginManager.logout = function()
  {

    StorageController.removeFromLocal(StorageController.keys.LOGGED_IN_USER);
    StorageController.clearAll();

    /*
    UserServices.logout()
      .finally(() =>
      {
      });

     */
  };

  LoginManager.login = function(username, password)
  {
    // LoginManager.logout(() =>
    // {
    //   _login(username, password, successCb, failCb);
    // });

    // We no longer logout since the server does that for us now
    return _login(username, password);
  };

  function _login(username, password)
  {
    $("html").addClass("waiting");

    StorageController.removeFromLocal(StorageController.keys.LOGGED_IN_USER);
    StorageController.clearAll();

    return UserServices.authenticateUser(username, password)
      // [catch] before [then] because [then] throws new errors which would otherwise be caught by this [catch]
      .catch((data) =>
      {
        // Fail
        log.error("Failed to authenticate - %o", data);
        $("html").removeClass("waiting");

        throw new AppError({
          data: {
            data,
            errorType: LoginManager.ERRORS.UNEXPECTED
          },
          exception: new Error("Unexpected error occurred")
        });
      })
      .then((data) =>
      {
        // Success
        let xmlDoc = $($.parseXML(data));
        let referrer = xmlDoc.find("access-control").attr("referer");
        let xmlData = xmlDoc.find("access-control").find("data").text();

        log.info("Login xml data: %s", xmlData);

        $("html").removeClass("waiting");

        if(isSuccess(xmlDoc))
        {
          let userData = utils.parseJSON(xmlData, true);

          if(utils.isNullOrEmpty(userData))
          {
            log.error("User data is empty in login response");

            throw new AppError({
              data: {
                data,
                errorType: LoginManager.ERRORS.NO_USER_DATA
              },
              exception: new Error("User data is empty in login response")
            });
          }

          if(!userData.hasOwnProperty("authenticated") || userData.authenticated)
          {
            // Success
            return {
              userData,
              referer: referrer
            };
          }
          else
          {
            // login failed (wrong credentials)
            throw new AppError({
              data: {
                data,
                errorType: LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT
              },
              exception: new Error("Tried to login with wrong credentials")
            });
          }
        }
        else if(isError(xmlDoc))
        {
          let errorData = utils.parseJSON(xmlData, true);

          if(utils.isNotNull(errorData))
          {
            if(errorData.incomplete)
            {
              //incomplete profile
              throw new AppError({
                data: {
                  data,
                  errorType: LoginManager.ERRORS.INCOMPLETE_PROFILE
                },
                exception: new Error("Tried to login while profile is incomplete")
              });
            }
            else if(utils.isNotNull(errorData.errorCode))
            {
              //incomplete profile
              throw new AppError({
                code: errorData.errorCode,
                data: {
                  data,
                  errorType: getErrorForCode(errorData.errorCode)
                },
                exception: new Error("Tried to login while profile is incomplete")
              });
            }
          }

          throw new AppError({
            data: {
              data,
              errorType: LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT
            },
            exception: new Error("Tried to login with wrong credentials")
          });
        }
        else
        {
          // always fun to say: should not come here... :)
          throw new AppError({
            data: {
              data,
              errorType: LoginManager.ERRORS.UNEXPECTED
            },
            exception: new Error("Unexpected error occurred")
          });
        }
      });
  }

  function is(what, xml)
  {
    return xml.find("access-control").attr("result") === what;
  }

  function isSuccess(xml)
  {
    return is("success", xml);
  }

  function isError(xml)
  {
    return is("error", xml);
  }

  function isNotLoggedIn(xml)
  {
    return is("null", xml);
  }

  function getErrorForCode(code)
  {
    if(code === "E45370")
    {
      return LoginManager.ERRORS.UNEXPECTED;
    }
    else if(code === "E55053")
    {
      return LoginManager.ERRORS.USER_NOT_VERIFIED;
    }

    return LoginManager.ERRORS.UNEXPECTED;
  }
})(LoginManager);

module.exports = LoginManager;



// WEBPACK FOOTER //
// ./app/js/services/login-manager.js